import {
  CcfAccordion,
  CcfAccordionDetails,
  CcfAccordionSummary,
  CcfAttachmentDownloadIcon,
  CcfBox,
  CcfButton,
  CcfDoubleArrowIcon,
  CcfImageIcon,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { styled } from '@mui/material/styles';
import styles from './ccf-wem-dashboard.module.scss';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Chip } from '@mui/material';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import { makeStyles } from '@mui/styles';
import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import CcfPreviewImage from '../../../ccf-preview-image/ccf-preview-image';
import { DownloadOutlined } from '@mui/icons-material';

/* eslint-disable-next-line */
export interface CcfWemSelectedSessionProps {
  isSessionSelected: any;
  setisSessionSelected: any;
  selectedSession: any;
}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      Height: '36px',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      maxHeight: '42px !important',
      minHeight: '42px !important',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',

      color: '#333333',
    },
  },
});
/**
 * CcfWemCoaching - used to display wem coaching
 * @param props - CcfWemCoaching
 * @example `<CcfWemCoaching />`-
 */
export function CcfWemSelectedSession(props: CcfWemSelectedSessionProps) {
  const { isSessionSelected, setisSessionSelected, selectedSession } = props;
  console.log('selectedSession', selectedSession);
  const classes = useStyles();
  const [translate] = useTranslator();
  const [expanded, setExpanded] = useState(true);
  /**@example */
  const handleChange = () => {
    setExpanded(!expanded);
  };

  const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
      theme.palette.mode === 'light'
        ? 'rgb(234, 241, 247)'
        : 'rgb(234, 241, 247)';
    return {
      backgroundColor,
      height: theme.spacing(3),
      fontWeight: 400,
      '&:hover, &:focus': {
        backgroundColor: 'rgb(234, 241, 247)',
      },
      '&:active': {
        boxShadow: theme.shadows[1],
        backgroundColor: 'rgb(234, 241, 247)',
      },
      '& .MuiChip-label': {
        display: 'flex',
        alignItems: 'center',
        fontWeight: '500',
        padding: '0px',
      },
      '& .MuiChip-icon': {
        order: 2, // Ensure the icon is displayed after the label
        color: 'rgb(0, 61, 122)',
        fontWeight: '400',
      },
    };
  }) as typeof Chip;

  const rowData = [
    {
      id: 1,
      fileName: 'TestFilewithAllowedType.png',
      fileLabel: 'TestFilewithAllowedType',
      type: 'Image',
      size: '3.36KB',
    },
  ];

  const columns = [
    {
      field: 'format',
      headerName: 'format'.toUpperCase(),
      width: 100,
      headerClassName: 'gridHeaderText',
      renderCell: (params: any) => {
        return (
          <CcfBox style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {' '}
            <img
              src="./assets/imageIcon.png"
              alt="imageIcon"
              style={{ width: '18px' }}
            />
          </CcfBox>
        );
      },
    },
    {
      field: 'fileName',
      headerName: 'file name'.toUpperCase(),
      width: 220,
    },
    {
      field: 'fileLabel',
      headerName: 'file label'.toUpperCase(),
      width: 190,
    },
    {
      field: 'type',
      headerName: 'type'.toUpperCase(),
      width: 150,
    },
    {
      field: 'size',
      headerName: 'size'.toUpperCase(),
      width: 330,
    },

    {
      field: '',
      headerName: 'actions'.toUpperCase(),
      headerClassName: 'gridHeaderText',
      renderCell: (params: any) => {
        return (
          <CcfBox style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <img
              src="./assets/downloadImage.png"
              alt="imageIcon"
              style={{ width: '18px' }}
            />
          </CcfBox>
        );
      },
    },
  ];

  return (
    <CcfBox>
      <CcfBox className={styles.headerParentGrid}>
        <CcfBox className={styles.titleParentGrid}>
          <Breadcrumbs aria-label="breadcrumb" aria-hidden="false" separator="">
            <StyledBreadcrumb
              component="a"
              id={`agent_selectedSession_breadcrumb`}
              style={{
                color: '#003D7A',
                fontWeight: '600',
                fontSize: '14px',
              }}
              label={translate('CoachingSessions')}
              aria-hidden="false"
              onClick={() => {
                setisSessionSelected(!isSessionSelected);
              }}
              icon={<NavigateNextIcon fontSize="small" />}
            />
          </Breadcrumbs>

          <CcfTypography className={styles.selectedSessionTitle}>
            {selectedSession?.focusArea}
          </CcfTypography>
        </CcfBox>

        <CcfBox style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <CcfButton
            className={styles.closeBtn}
            onClick={() => {
              setisSessionSelected(!isSessionSelected);
            }}
          >
            {translate('close')}
          </CcfButton>
          <CcfButton primary className={styles.acknowledgeBtn}>
            {translate('acknowledge')}
          </CcfButton>
        </CcfBox>
      </CcfBox>
      <CcfBox style={{ height: 'calc(100vh - 190px)' }}>
        <CcfBox className={styles.selectedSessionTopBar}>
          <div className={styles.headerLabelGrid}>
            <CcfTypography style={{ fontWeight: '600', fontSize: '12px' }}>
              {' '}
              {selectedSession?.focusArea}
            </CcfTypography>
            <span className={styles.piped}></span>
            <CcfTypography className={styles.headerItem}>
              {' '}
              Coach Name: {selectedSession?.coachName}
            </CcfTypography>
            <span className={styles.piped}></span>
            <CcfTypography className={styles.headerItem}>
              {selectedSession?.coachingType}
            </CcfTypography>
          </div>
          <div style={{ paddingRight: '20px' }}>
            <CcfBox
              style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
            >
              {' '}
              {selectedSession.status === 'Overdue' ? (
                <img
                  src="./assets/OverdueIcon.png"
                  alt="OverdueIcon"
                  style={{ width: '18px' }}
                />
              ) : selectedSession.status === 'Completed' ? (
                <CheckCircleOutlineOutlinedIcon
                  htmlColor={'#39C44A'}
                  style={{ width: '20px' }}
                />
              ) : (
                <img
                  src="./assets/Scheduled.png"
                  alt="Scheduled"
                  style={{ width: '18px' }}
                />
              )}
              <CcfTypography style={{ fontSize: '11px', color: '#2e2e2e' }}>
                {selectedSession?.status}
              </CcfTypography>
            </CcfBox>
          </div>
        </CcfBox>
        <CcfBox style={{ height: 'calc(100% - 40px)', overflowY: 'auto' }}>
          <div className={styles.selectedSessionReadonlyGrid}>
            <div
              className={styles.gridCell}
              style={{ gridArea: '1 / 1 / 2 / 2' }}
            >
              <CcfTypography className={styles.gridCellField}>
                Employee
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>
                {selectedSession?.coachName}
              </CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '1/2/2/3' }}>
              <CcfTypography className={styles.gridCellField}>
                Focus Area
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>
                {selectedSession?.focusArea}
              </CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '1/3/2/4' }}>
              <CcfTypography className={styles.gridCellField}>
                Behavior
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>
                Effectively Multi-Tasking
              </CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '1/4/2/5' }}>
              <CcfTypography className={styles.gridCellField}>
                Metric
              </CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '1/5/2/6' }}>
              <CcfTypography className={styles.gridCellField}>
                Coaching Date
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>
                {selectedSession?.coachingDate}
              </CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '1/5/2/6' }}>
              <CcfTypography className={styles.gridCellField}>
                Coaching Date
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>
                {selectedSession?.coachingDate}
              </CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '1/6/2/7' }}>
              <CcfTypography className={styles.gridCellField}>
                Last updated
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>
                {selectedSession?.lastUpdated}
              </CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '1/7/2/8' }}>
              <CcfTypography className={styles.gridCellField}>
                ACKNOWLEDGMENT DUE BY{' '}
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>
                {selectedSession?.acknowledgmentDueDate}
              </CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '2/5/3/8' }}>
              <CcfTypography className={styles.gridCellField}>
                Scheduled Date{' '}
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>-</CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '2/6/3/8' }}>
              <CcfTypography className={styles.gridCellField}>
                Scheduled Time{' '}
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>-</CcfTypography>{' '}
            </div>

            <div className={styles.gridCell} style={{ gridArea: '3/5/3/8' }}>
              <CcfTypography className={styles.gridCellField}>
                Preparation Time (min)
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>-</CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '3/6/4/8' }}>
              <CcfTypography className={styles.gridCellField}>
                Spent Time (min)
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>-</CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '3/7/5/8' }}>
              <CcfTypography className={styles.gridCellField}>
                VIEWERS
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>-</CcfTypography>{' '}
            </div>
            <div className={styles.gridCell} style={{ gridArea: '2/1/6/5' }}>
              <CcfTypography className={styles.gridCellField}>
                Objective
              </CcfTypography>{' '}
              <CcfTypography style={{ fontSize: '14px' }}>
                Objective to test session creation
              </CcfTypography>{' '}
            </div>
          </div>
          <div className={styles.viewResourcesTitle}>
            <div style={{ marginBottom: '8px' }}>
              <span className={styles.contentTitle}>
                {translate('resources')}
              </span>
            </div>
            <hr className={styles.hrDivider} />
          </div>
          <div>
            {' '}
            <CcfAccordion
              square
              className={styles.accordionContainer}
              expanded={expanded}
              onChange={() => {
                handleChange();
              }}
            >
              <CcfAccordionSummary
                expandIcon={
                  <CcfDoubleArrowIcon className={styles.expandedIcon} />
                }
                aria-controls="detail-content"
                className={styles.accordionHeader}
                sx={{
                  '&.MuiAccordionSummary-root.Mui-expanded': {
                    margin: '0',
                    minHeight: '40px',
                  },
                }}
              >
                <CcfTypography className={styles.accordianTitle}>
                  {translate('attachments').toUpperCase()}
                </CcfTypography>
              </CcfAccordionSummary>
              <CcfAccordionDetails style={{ padding: '0px' }}>
                <CcfBox
                  style={{
                    height: '85px',
                    backgroundColor: '#f2f7fa',
                    overflowY: 'hidden',
                    borderTop: '1px solid #E1E1E1',
                    boxShadow: '0 2px 6px #1f324d33',
                  }}
                  id={`agent_wem_selectedSession_dataGridContainer`}
                >
                  <DataGrid
                    classes={{ root: classes.root }}
                    rows={rowData}
                    columns={columns}
                    rowHeight={40}
                    getRowId={(row) => row?.id}
                    pageSize={10}
                    headerHeight={40}
                    hideFooter
                    hideFooterPagination
                    // autoHeight
                    disableSelectionOnClick
                    pagination
                    rowsPerPageOptions={[5, 10, 25]}
                    getRowClassName={(params: any) => `styledrows`}
                    sx={{
                      '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#3F5C69',
                        fontWeight: '600',
                        fontSize: '12px',
                        fontFamily: 'Open Sans',
                      },
                    }}
                  />
                </CcfBox>
              </CcfAccordionDetails>
            </CcfAccordion>
          </div>
          <div className={styles.viewResourcesTitle}>
            <div style={{ marginBottom: '8px' }}>
              <span className={styles.contentTitle}>
                {translate('notes').toUpperCase()}
              </span>
            </div>
            <hr className={styles.hrDivider} />
          </div>
        </CcfBox>
      </CcfBox>
    </CcfBox>
  );
}
